import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'

import 'app/App.module.scss'
import { BottomArc } from 'components/bottomArc/BottomArc'
import { DescriptionSection } from 'components/descriptionSection/DescriptionSection'
import { HeroBanner } from 'components/heroBanner/HeroBanner'
import { IdeasSection } from 'components/ideasSection/IdeasSection'
import { QuickLinks } from 'components/quickLinks/QuickLinks'
import { StepSection } from 'components/stepSection/StepSection'
import { StrategySection } from 'components/strategySection/StrategySection'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

export function App() {

  useEffect(() => {
    trackAnalytics({
      type: AnalyticsActionType.page,
      payload: EVENTS.PLAYGROUND_PRIORITIZATION,
    })
  }, [])

  return (
    <BrowserRouter basename="/prioritization-process">
      <HeroBanner />
      <IdeasSection />
      <DescriptionSection />
      <StrategySection />
      <StepSection />
      <QuickLinks />
      <BottomArc />
    </BrowserRouter>
  )
}
